<template>
  <div>
    <div class="p-box">
      <div class="p-box__body">
        <div class="p-box">
          <div class="p-box__header">
            <p class="p-box__title">
              {{ $t('pages.companies.postApprovalFlowForm.header') }}
            </p>
          </div>
          <div class="p-box__body">
            <Info>
              {{ $t('pages.companies.postApprovalFlowForm.info') }}
            </Info>
            <form v-if="!loading" @submit.prevent="handleSubmit(onSubmit)">
              <span class="c-radio__item">
                <input
                  id="on"
                  v-model="inputApprovalFlow"
                  type="radio"
                  :value="true"
                  class="c-radio__input"
                >
                <label for="on" class="c-radio__label">
                  {{ $t('pages.companies.postApprovalFlowForm.on') }}
                </label>
              </span>
              <span class="c-radio__item">
                <input
                  id="off"
                  v-model="inputApprovalFlow"
                  type="radio"
                  :value="false"
                  class="c-radio__input"
                >
                <label for="off" class="c-radio__label">
                  {{ $t('pages.companies.postApprovalFlowForm.off') }}
                </label>
              </span>
            </form>
            <Loading v-else />
          </div>
        </div>
        <div class="c-button c-button--right">
          <router-link
            class="c-button__item c-button__item--outline-cancel"
            :to="{
              name: 'CompaniesManagement',
              params: { company_uuid: currentCompanyUuid }
            }"
          >
            {{ $t('labels.cancel') }}
          </router-link>
          <button class="c-button__item c-button__item--primary" @click="onSubmit()">
            {{ $t('labels.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Loading from '../components/Loading'
import Info from '../components/Info'

export default {
  components: {
    Loading,
    Info
  },
  data() {
    return {
      inputApprovalFlow: false
    }
  },
  computed: {
    ...mapState({
      companyApprovalFlow: state => state.companiesPostsManagementsApprovalFlows.data,
      loading: state => state.companiesPostsManagementsApprovalFlows.loading
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    }
  },
  async created() {
    await this.readApprovalFlow()
    this.inputApprovalFlow = this.companyApprovalFlow.postApprovalFlow
  },
  methods: {
    ...mapActions({
      readApprovalFlow: 'companiesPostsManagementsApprovalFlows/readApprovalFlow',
      updateApprovalFlows: 'companiesPostsManagementsApprovalFlows/updateApprovalFlow'
    }),
    async onSubmit() {
      if (!this.inputApprovalFlow && this.companyApprovalFlow.hasRequestingPost) {
        alert(this.$t('pages.companies.postApprovalFlowForm.invalidAlert'))
        return
      }

      const payload = {
        post_management_approval_flow: {
          post_approval_flow: this.inputApprovalFlow
        }
      }
      const isSuccess = await this.updateApprovalFlows(payload)
      if (isSuccess)
        this.$router.push({
          name: 'CompaniesManagement',
          params: { company_uuid: this.currentCompanyUuid }
        })
    }
  }
}
</script>
<style lang="scss" scoped></style>
